module.exports = __webpack_public_path__ + "static/media/upload-employees-jobs-example.bb13d099.png";